import { render } from "./App.vue?vue&type=template&id=37021ea0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=37021ea0&lang=scss"

import exportComponent from "/Users/yannic/Code/hoppmann-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__